import type { ThemeStyledProps, BoxProps } from '@withjoy/joykit';
import { styled, Box } from '@withjoy/joykit';
import type { ConfigStyle } from 'styled-system';
import { system } from 'styled-system';
import type { ColumnInset, ContentColumnProps } from './ContentColumn';

const _insetToValue: Readonly<Record<ColumnInset, number>> = {
  none: 0,
  md: 64,
};

const _styleFn = system({
  leftInset: {
    property: 'marginLeft',
    transform: (value: Maybe<ColumnInset>, scale: unknown, props: ThemeStyledProps<ContentColumnProps>) => {
      return value ? props.theme.typography.pxToRem(_insetToValue[value]) : undefined;
    },
  } as Readonly<ConfigStyle>,
});

export const StyledRoot = styled(Box)<BoxProps & { leftInset?: ContentColumnProps['leftInset'] }>`
  ${_styleFn}
`;
